// Import the old JavaScript file(s)
import '../js/app.js';
import 'chart.js';
import 'animate.css';
import lozad from 'lozad';
import axios from 'axios';
import { TokenStorageService } from './tokenStorage.js';
// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'mdb-ui-kit';
import '@fortawesome/fontawesome-free/css/all.css';

// import custom scripts
import './header.ts'
import Cookies from 'js-cookie';

// Lozad.js initialization (for lazy loading)
const observer = lozad('.lozad');
// Initialize lozad with custom load and error handlers
const observerBackground = lozad('.lozad-bg', {
    loaded: function(el) {
        const bgImageUrl = el.getAttribute('data-background-image');
        const placeholder = el.getAttribute('data-placeholder-background')
        el.style.backgroundImage = `url('${placeholder}')`;

        // Create an image to check if it loads
        const img = new Image();
        img.src = bgImageUrl;

        img.onload = function() {
            // Set the background image if it loads successfully
            el.style.backgroundImage = `url('${bgImageUrl}')`;
        };
    }
});

// Trigger the observer
observerBackground.observe();
observer.observe();

const tokenStorageService = new TokenStorageService();

// initialize axios
// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        // Get token from storage
        const token = tokenStorageService.getToken();
        if (token) {
            // Set the Authorization header for every request
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
        // Check if the error status is 401 or 403
        if (error.response.status === 401 || error.response.status === 403) {
            tokenStorageService.signOut(); // Clear token on unauthorized access
            window.location.href = '/logout'; // Redirect to login
        }
        }
        return Promise.reject(error);
    }
);

export function formatTimeDifference(time: string): string {
    if (!time) {
        return "undefined";
    }

    // Calculate difference in time in minutes
    const today = new Date();
    const differenceTimeZone = today.getTimezoneOffset() * 60 * 1000;
    const timeDate = new Date(time);
    const diffTime = (today.getTime() + differenceTimeZone - timeDate.getTime()) / 1000;
    const minDiff = Math.abs(Math.round(diffTime / 60));

    // Transform based on minutes
    if (minDiff <= 1) {
        return "1 minute";
    } else if (minDiff === 2) {
        return "2 minutes";
    } else if (minDiff >= 3 && minDiff <= 60) {
        return `${minDiff} minutes`;
    } else {
        const hoursDiff = Math.abs(Math.round(minDiff / 60));

        if (hoursDiff === 1) {
            return "one hour";
        } else if (hoursDiff === 2) {
            return "two hours";
        } else if (hoursDiff >= 3 && hoursDiff <= 24) {
            return `${hoursDiff} hours`;
        } else {
            // Format date as dd/MM/yyyy
            return formatDate(timeDate);
        }
    }
}

// Helper function to format date as dd/MM/yyyy
function formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}
